import { signOut } from 'firebase/auth'
import { auth } from '../../firebase/firebase'

export default async function firebaseLogout() {
  return await signOut(auth)
}
